import { parseRRule, serializeRRule } from "./rrule-codec.js";
//#region src/components/RRule/utils/schedule.ts
/**
* Single source of truth for ICS weekday tokens ('MO'..'SU') ↔ Atalaya
* Week key mapping.
*/
var RRULE_WEEKDAYS = [
	{
		key: "monday",
		label: "Mon",
		rrule: "MO"
	},
	{
		key: "tuesday",
		label: "Tue",
		rrule: "TU"
	},
	{
		key: "wednesday",
		label: "Wed",
		rrule: "WE"
	},
	{
		key: "thursday",
		label: "Thu",
		rrule: "TH"
	},
	{
		key: "friday",
		label: "Fri",
		rrule: "FR"
	},
	{
		key: "saturday",
		label: "Sat",
		rrule: "SA"
	},
	{
		key: "sunday",
		label: "Sun",
		rrule: "SU"
	}
];
var DEFAULT_SCHEDULE = {
	frequency: "daily",
	monthDays: [],
	startTimeOfDay: {
		hour: 0,
		minute: 0
	},
	weekdays: []
};
function scheduleFromRRule(rruleString) {
	const parts = parseRRule(rruleString);
	if (!parts) return DEFAULT_SCHEDULE;
	const frequency = parts.freq === "WEEKLY" ? "weekly" : parts.freq === "MONTHLY" ? "monthly" : "daily";
	return {
		frequency,
		monthDays: frequency === "monthly" ? parts.byMonthDay : [],
		startTimeOfDay: {
			hour: parts.byHour,
			minute: parts.byMinute
		},
		weekdays: frequency === "weekly" ? parts.byDay : []
	};
}
function createDefaultRRuleString(now = /* @__PURE__ */ new Date(), timeZone) {
	return serializeRRule({
		byDay: [],
		byHour: 10,
		byMinute: 0,
		byMonthDay: [],
		bySecond: 0,
		freq: "DAILY"
	}, timeZone, now);
}
function scheduleToRRule(schedule, timeZone) {
	const freq = schedule.frequency === "weekly" ? "WEEKLY" : schedule.frequency === "monthly" ? "MONTHLY" : "DAILY";
	return serializeRRule({
		byDay: schedule.weekdays,
		byHour: schedule.startTimeOfDay.hour,
		byMinute: schedule.startTimeOfDay.minute,
		byMonthDay: schedule.monthDays,
		bySecond: 0,
		freq
	}, timeZone);
}
//#endregion
export { RRULE_WEEKDAYS, createDefaultRRuleString, scheduleFromRRule, scheduleToRRule };

//# sourceMappingURL=schedule.js.map